<template>
  <div
    id="templateBarcodeModal"
    class="modal fade"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-4">
                    <div class="form-group">
                      <label class="label-required"
                        >ชื่อเจ้าของทรัพย์สิน:</label
                      >
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'tpbAssetOwnerId'"
                        :name="'tpbAssetOwnerId'"
                        :select2-options="tpbAssetOwnerOptions"
                        v-model="tpbAssetOwnerId"
                        ref="tpbAssetOwnerSelect2"
                      ></select2>
                    </div>
                  </div>
                  <div class="col-xl-4">
                    <div class="form-group">
                      <label class="label-required">สินค้า:</label>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'tpbProductId'"
                        :name="'tpbProductId'"
                        :select2-options="tpbProductOptions"
                        v-model="tpbProductId"
                        ref="tpbProductSelect2"
                      ></select2>
                    </div>
                  </div>
                  <div class="col-xl-4">
                    <div class="form-group">
                      <label class="label-required">Supplier:</label>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'tpbVendorId'"
                        :name="'tpbVendorId'"
                        :select2-options="tpbVendorOptions"
                        v-model="tpbVendorId"
                        ref="tpbVendorIdSelect2"
                      ></select2>
                    </div>
                  </div>
                  <div class="col-xl-4">
                    <div class="form-group">
                      <label class="label-required">จำนวน:</label>
                      <input
                        id="qty"
                        name="qty"
                        v-model="qty"
                        type="number"
                        min="1"
                        maxlength="256"
                        class="form-control"
                        placeholder="จำนวน"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> ดาวน์โหลด
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;
    return {
      qty: null,
      tpbAssetOwnerId: null,
      tpbProductId: null,
      tpbVendorId: null,
      tpbProductOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2ProductByType",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              productTypeId: [],
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      tpbVendorOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      tpbAssetOwnerOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/assetOwner/Select2SearchAssetOwner",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();

      if (
        !$("#templateBarcodeModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดาวโหลด Template Barcode กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;
      var win = window.open(
        "/Api/Barcode/DownloadTemplate?AssetOwnerId=" +
          self.tpbAssetOwnerId +
          "&VendorId=" +
          self.tpbVendorId +
          "&ProductId=" +
          self.tpbProductId +
          "&Rows=" +
          self.qty,
        "_blank"
      );
      win.focus(KTApp.unblockPage());
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    // set validation rules
    $("#templateBarcodeModal form").validate({
      rules: {
        tpbAssetOwnerId: "required",
        tpbProductId: "required",
        qty: "required",
        tpbVendorId:"required",
      },
      messages: {
        tpbAssetOwnerId: "กรุณาเลือกชื่อเจ้าของทรัพย์สิน",
        tpbProductId: "กรุณาเลือกสินค้า",
        qty: "กรุณาระบุจำนวน",
        tpbVendorId:"กรุณาเลือก Supplier",
      },
    });

    $("#templateBarcodeModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        // self.$parent.reloadDataTable(false);
      })
      .modal("show");
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Barcode/TemplateBarcode.vue